




























import {Component} from 'vue-property-decorator';

import Vue from 'vue';
import { Action, Getter } from 'vuex-class';
import { ActionTypes, GetterTypes } from '@/modules/neopvc/store/types';
import { tabs } from '@/modules/neopvc/models';
import { AuditEntry } from '@/modules/neopvc/models/auditEntry';
import moment from 'moment';


@Component({})
export default class extends Vue {
  @Getter(GetterTypes.GET_AUDIT_ENTRIES)
  public AuditEntries: AuditEntry[];

  @Action(ActionTypes.FETCH_AUDIT_ENTRIES)
  public getAuditEntriesAsync: () => Promise<void>;

  @Action(ActionTypes.UPDATE_CURRENT_TAB)
  public updateCurrentTab: (tab: string) => void;

  public isLoading = false;

  public async created() {
    this.updateCurrentTab(tabs.audit);
    await this.getAuditEntriesAsync();
  }

  public formatDate(value: string) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm');
  }

  public get noData() {
    return this.isLoading
        ? 'Buscando projetos...'
        : 'Nenhum dado de auditoria de carga encontrado.';
  }

  public get auditHeader() {
    return [
      { text: 'Tipo Carga', value: 'description', sortable: false },
      { text: 'Data Inicio', value: 'startedAt', sortable: false },
      { text: 'Data Fim', value: 'finalizedAt', sortable: false },
      { text: 'Qt. Linhas', value: 'numberOfRows', sortable: false },
      { text: 'Finalizado', value: 'isFinalizedDescription', sortable: false },
    ];
  }

}
